<span class="data-label font-size-14px" [ngClass]="fontSize">Directions: </span>
<span
    class="data-value font-size-14px"
    [ngClass]="fontSize"
    [innerHTML]="assessmentDirection"
></span>
